import * as React from 'react';
import {ProductsCategoryFilterDesktop} from './views/desktop';
import {ProductsCategoryFilterMobile} from './views/mobile';
import {ProductsCategoryFilterVisuallyImpaired} from './views/visuallyImpaired';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {ProductsCategoryFilterViewBaseProps} from '../model';

interface Props extends ProductsCategoryFilterViewBaseProps {
  visuallyImpaired?: boolean;
}

export default ({visuallyImpaired, ...props}: Props) => {
  const isDesktop = useIsDesktop();

  if (visuallyImpaired) {
    return <ProductsCategoryFilterVisuallyImpaired {...props} />;
  } else {
    return isDesktop ? <ProductsCategoryFilterDesktop {...props} /> : <ProductsCategoryFilterMobile {...props} />;
  }
};
